module.exports = __webpack_public_path__ + "img/step3-t.d6abc48b.png";